// Deterministic color for an area name so the same room always shows the same
// dot everywhere (schedule, my day, crew sheet). No setup required.
const PALETTE = [
  "#2dd4bf", // teal
  "#fbbf24", // amber
  "#818cf8", // indigo
  "#f472b6", // pink
  "#34d399", // emerald
  "#22d3ee", // cyan
  "#a78bfa", // violet
  "#fb923c", // orange
  "#fb7185", // rose
  "#a3e635", // lime
  "#38bdf8", // sky
  "#e879f9", // fuchsia
];

export function areaColor(name) {
  const s = String(name || "");
  let h = 0;
  for (let i = 0; i < s.length; i++) h = (h * 31 + s.charCodeAt(i)) >>> 0;
  return PALETTE[h % PALETTE.length];
}
